import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { DataBlocks, Link, I18n } from 'components';
import { formatUnitString } from 'utils/formatString';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const WarrantyPayments = ({ data, userType, error }) => {
  if (userType === 'prepaid') {
    return null;
  }
  if (error && error.type || data && data.error) {
    return null;
  }
  if (!data) {
    return null;
  }

  const deposits = data.deposits.filter((d) => d.status === 'Paid' || d.status === 'Required');

  if (!deposits.length) {
    return null;
  }

  return (
    <DataBlocks.Block
      title={<I18n path="home.warrantyPayments.title" />}
      subtitle={<I18n path="home.warrantyPayments.description" />}
    >
      <DataBlocks.Table>
        {deposits.map((deposit, index) => (
          <DataBlocks.TableRow key={deposit.title + index}>
            <DataBlocks.TableCell>
              {deposit.tariffUrl ? (
                <Link href={deposit.tariffUrl}>
                  {deposit.title}
                </Link>
              ) : (
                deposit.title
              )}
            </DataBlocks.TableCell>
            <DataBlocks.TableCell>
              {formatUnitString(deposit.value, deposit.currency)}
            </DataBlocks.TableCell>
            <DataBlocks.TableCell>
              <I18n path={`home.warrantyPayments.statuses.${deposit.status}`} />
              {deposit.status === 'Required' && (
                <div className={cx('message')}>
                  для подключения
                  {' '}
                  <Link href={data.paymentUrl}>
                    оплатить
                  </Link>
                  {' '}
                  {formatUnitString(deposit.unpaid, deposit.currency)}
                </div>
              )}
            </DataBlocks.TableCell>
          </DataBlocks.TableRow>
        ))}
      </DataBlocks.Table>
    </DataBlocks.Block>
  );
};

WarrantyPayments.propTypes = {
  data: PropTypes.object,
  userType: PropTypes.string,
  error: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    data: state.home.guaranteePayment.data,
    userType: state.application.settings.userType,
    error: state.home.guaranteePayment.error,
  };
}

export default connect(mapStateToProps)(WarrantyPayments);
